var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbmcad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 19,
    rx: 3.5,
    fill: "#1042A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 14.875H10.25V13.625H6.5V7.375H10.25V6.125H6.5C6.16848 6.125 5.85054 6.2567 5.61612 6.49112C5.3817 6.72554 5.25 7.04348 5.25 7.375V13.625C5.25 13.9565 5.3817 14.2745 5.61612 14.5089C5.85054 14.7433 6.16848 14.875 6.5 14.875ZM15.25 6.125H12.75C12.4185 6.125 12.1005 6.2567 11.8661 6.49112C11.6317 6.72554 11.5 7.04348 11.5 7.375V14.875H12.75V11.75H15.25V14.875H16.5V7.375C16.5 7.04348 16.3683 6.72554 16.1339 6.49112C15.8995 6.2567 15.5815 6.125 15.25 6.125ZM12.75 10.5V7.375H15.25V10.5H12.75ZM22.0178 14.1428C21.5489 14.6116 20.913 14.875 20.25 14.875H17.75V6.125H20.25C20.913 6.125 21.5489 6.38839 22.0178 6.85723C22.4866 7.32607 22.75 7.96196 22.75 8.625V12.375C22.75 13.038 22.4866 13.6739 22.0178 14.1428ZM19 13.625H20.25C20.5815 13.625 20.8995 13.4933 21.1339 13.2589C21.3683 13.0245 21.5 12.7065 21.5 12.375V8.625C21.5 8.29348 21.3683 7.97554 21.1339 7.74112C20.8995 7.5067 20.5815 7.375 20.25 7.375H19V13.625Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 19,
    rx: 3.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmcad);
export default __webpack_public_path__ + "static/media/IBMCAD.c2eb8067.svg";
export { ForwardRef as ReactComponent };